export const mockedBillingAccountsData = {
  totalCount: 10,
  totalCreditLimit: 30000,
  creditOutstanding: 21859.67,
  availableCreditLimit: 8140.33,
  paymentMethod: 'NET30',
  currency: 'USD',
  status: 'ELIGIBLE',
  nodes: [
    {
      taxId: '19AAQCA7616M2ZZ',
      creditOutstanding: 21859.67,
      status: 'ELIGIBLE',
      customerName: 'SK-Push TxA 1',
      transactionAccountNumber: 'AC-3ZKM-J4ME-7GGA',
      pendingInvoiceRequestsTotal: 0,
      __typename: 'TermDetailsAccount',
    },
    {
      taxId: '19AAQCA7616M2ZA',
      creditOutstanding: 21859.67,
      status: 'ELIGIBLE',
      customerName: 'SK-Push TxA 2',
      transactionAccountNumber: 'AC-3ZKM-J4ME-7GGB',
      pendingInvoiceRequestsTotal: 0,
      __typename: 'TermDetailsAccount',
    },
  ],
  __typename: 'TermDetailsAccountConnection',
};

export const mockedBillingAccountsDataWithMissingFields = {
  totalCount: 10,
  totalCreditLimit: 30000,
  creditOutstanding: null,
  availableCreditLimit: null,
  paymentMethod: 'NET30',
  currency: 'USD',
  status: 'ELIGIBLE',
  nodes: [
    {
      taxId: '19AAQCA7616M2ZZ',
      creditOutstanding: null,
      status: 'ELIGIBLE',
      customerName: null,
      transactionAccountNumber: 'AC-3ZKM-J4ME-7GGA',
      pendingInvoiceRequestsTotal: 0,
      __typename: 'TermDetailsAccount',
    },
  ],
  __typename: 'TermDetailsAccountConnection',
};
